import RentalTableRow from "../common/Rentals/RentalTableRow";

const PROPERTY_GUIDE_ROW_CONFIG = {
  showGuideInfo: true,
  showPmsId: false,
  showEditButton: true,
  showViewButton: true,
  showPrintButton: true,
  showShareButton: true,
  showMonitoringButton: true,
  showQRButton: true,
  showCloneButton: true,
  showDetailButton: false,
  editPath: "properties/{id}",
  viewUrl: "https://guide.ruebarue.com/rental/{id}",
  printUrl: "https://guide.ruebarue.com/rental/{id}/print",
  shareModalId: "#share-modal",
  monitoringModalId: "#smart-lock-monitoring-modal",
  deleteModalId: "#modal-property-delete",
};

const TableRow = ({ guide, index, allTags, onZoneToggle, canManage = true }) => {
  return (
    <RentalTableRow
      guide={guide}
      index={index}
      allTags={allTags}
      config={PROPERTY_GUIDE_ROW_CONFIG}
      onZoneToggle={onZoneToggle}
      canManage={canManage}
    />
  );
};

export default TableRow;
